import React from 'react';

interface ScopesEmptyStateProps {
  hasTenant: boolean;
  isImporting: boolean;
  m365ImportEnabled: boolean;
  onImportFromM365: () => void;
  onStartBlank: () => void;
  onOpenAdvanced: () => void;
}

/**
 * Shown when the tenant has no published Scopes and no draft imports
 * yet. Start blank is always available without Microsoft Graph. The optional
 * Microsoft 365 organisation import appears only when its separately
 * consented feature is enabled. Start blank seeds a single root entry on the
 * Import Draft form (the API requires at least one entry). JSON paste
 * is intentionally a quiet "Advanced" link.
 */
export const ScopesEmptyState: React.FC<ScopesEmptyStateProps> = ({
  hasTenant,
  isImporting,
  m365ImportEnabled,
  onImportFromM365,
  onStartBlank,
  onOpenAdvanced
}) => {
  return (
    <div className="scopes-empty">
      <h3>{hasTenant ? 'No Scopes yet' : 'Pick a tenant to begin'}</h3>
      <p>
        Scopes describe where work belongs inside the business — Goods Intake, Site A,
        Finance, and so on. Audits, Findings, Actions, templates and reports all hang
        off the same tree.
      </p>
      <div className="scopes-empty-actions">
        <button
          className="btn"
          type="button"
          onClick={onStartBlank}
          disabled={!hasTenant || isImporting}
        >
          Start from blank
        </button>
        {m365ImportEnabled && (
          <button
            className="btn secondary"
            type="button"
            onClick={onImportFromM365}
            disabled={!hasTenant || isImporting}
          >
            {isImporting ? 'Importing from Microsoft 365...' : 'Import from Microsoft 365'}
          </button>
        )}
      </div>
      <div className="advanced">
        Or{' '}
        <button type="button" className="link-button" onClick={onOpenAdvanced} disabled={!hasTenant}>
          paste a Scope as JSON
        </button>
        {' '}(advanced).
      </div>
    </div>
  );
};

export default ScopesEmptyState;
